// extracted by mini-css-extract-plugin
export default {"nav_modal":"styles_nav_modal__rcS99","nav_modal_container":"styles_nav_modal_container__EFSeI","nav_close_btn":"styles_nav_close_btn__gxEji"};